'use client';

import Image from 'next/image';
import React from 'react';
import cn from 'classnames';
import { CSSVars } from '../../styles/styles.config';
import { IContentPage, IContentPageFeature } from '../../types';
import { Banner } from '../banner/banner.comp';
import { Feature } from '../feature/feature.comp';
import { StyledDiv } from './contentPageFeatures.styles';
import { StyledDiv as FeatureStyledDiv } from '../feature/feature.styles';
import { CommonNinjaWidgetRenderer } from '../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp';

export const ContentPageFeatures = ({
	contentPage,
}: {
	contentPage: IContentPage;
}) => {
	function renderFeature(feature: IContentPageFeature) {
		const isWriteForUsPage = contentPage.slug.includes('write-for-us');
		
		switch (feature.type) {
			case 'widget':
				return (
					<>
						<FeatureStyledDiv
							className={`full-width feature`}
							style={{
								marginTop: isWriteForUsPage ? '-200px' : '0',
								justifyContent: 'center',
								textAlign:
									feature.position === 'top-to-bottom' ? 'center' : 'left',
							}}
						>
							<div className="content">
								<div className={`details-wrapper`}>
									<div className="wrapper">
										{feature.title && <h2>{feature.title}</h2>}
										{feature.subtitle && <h3>{feature.subtitle}</h3>}
									</div>
								</div>
							</div>
						</FeatureStyledDiv>
						<CommonNinjaWidgetRenderer
							style={{ minHeight: isWriteForUsPage ? '700px' : '0' }}
							key={feature.text + ' pluginId'}
							widgetId={feature.pluginId || ''}
						/>
					</>
				);

			case 'banner':
				return (
					<Banner
						key={feature.text + ' banner'}
						title={feature.title}
						text={feature.text}
						isHtml={true}
						bannerStyle={{
							background: '#FAFAFC',
							border: `1px solid ${CSSVars.gray200}`,
							color: '#141414',
							padding: '50px',
						}}
						style={{ padding: 0 }}
						buttonText={feature.buttonText}
						buttonLink={
							feature.buttonPath?.[0] === '/'
								? feature.buttonPath
								: `/${feature.buttonPath}`
						}
						openInNewWindow={feature.target === '_blank'}
					/>
				);

			default:
				return (
					<Feature
						key={feature.text}
						title={feature.title}
						subtitle={feature.subtitle}
						imgCaption={feature.imgCaption}
						text={feature.text}
						isHtml={true}
						position={
							feature.position === 'top-to-bottom' ? 'ttb' : feature.position
						}
						alt={feature.imgAlt}
						img={feature.imgUrl}
						linkPath={feature.buttonPath || ''}
						linkText={feature.buttonText || ''}
						openInNewWindow={feature.target === '_blank'}
						pluginId={feature.pluginId}
					/>
				);
		}
	}

	return (
		<>
			{contentPage.hero && (
				<StyledDiv>
					<Image
						className="main-image"
						src={contentPage.hero}
						alt={`${contentPage.name}`}
						width={930}
						height={520}
					/>
				</StyledDiv>
			)}
			{contentPage.features.length > 0 && (
				<StyledDiv>
					<div
						className={cn('features-container', contentPage.slug, {
							'full-width': contentPage.isFullPage,
						})}
					>
						{contentPage.features.map((feature) => renderFeature(feature))}
					</div>
				</StyledDiv>
			)}
		</>
	);
};
